import classnames from 'classnames'
import React, { FC } from 'react'
import { Languages } from '../../interfaces/common'
import style from './LocalizedLogo.module.css'
import LogoIcon from './assets/LogoIcon'
import LogoKzIcon from './assets/LogoKzIcon'
import LogoUzIcon from './assets/LogoUzIcon'

const logo = {
  [Languages.RU]: <LogoIcon className={style.logoRU} />,
  [Languages.KZ]: <LogoKzIcon className={style.logoKZ} />,
  [Languages.UZ]: <LogoUzIcon className={style.logoUZ} />,
}

type LocalizedLogoProps = {
  className?: string
  locale: Languages
}

export const LocalizedLogo: FC<LocalizedLogoProps> = ({ className, locale }) => {
  const computedClassName = classnames(style.logo, className)

  return <div className={computedClassName}>{logo[locale]}</div>
}

LocalizedLogo.displayName = 'LocalizedLogo'
